import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { Helmet } from "react-helmet";
import { Row, Col, Button } from "reactstrap";
import axios from 'axios';
import Table from "./../../components/general/Table/Table";
import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import Loading from "../../components/wrapper/Loading/Loading";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class InventoryPage extends Component{

state = {
  inventoryTableData: [],
  isLoading: true
};

constructor(props){
  super(props);
  this.getInventoryData();
}

  getInventoryData = () => {
    // this.setState({
    //   isLoading: true
    // })
    trackPromise(
      axios
      .get(`${process.env.REACT_APP_API_HOST}/truck/unassigned`, {withCredentials: true})
      .then((response) => {
        let unassigned_trucks = response.data.unassigned_trucks
        .map((truck) => {
          return [truck.vendor_name, truck.vendor_city, truck.name, truck.license_plate, truck.size_ref, truck.make];
        });
        this.setState({
          inventoryTableData: unassigned_trucks,
          isLoading: false
        });
      }).catch((err) => {
        this.setState({
          isLoading: false
        })
        console.log(err);
      })
    );
  };

inventoryTableHeaders = ["Vendor Name", "Vendor City", "Truck Name", "License Plate", "Size Ref", "Make"];

render(){
  return (
    <Fragment>
      <Loading loading={this.state.isLoading} label="Loading Available Inventory..."></Loading>
      <Helmet>
        <title>Boxi Admin | Available Inventory</title>
      </Helmet>
      <Row className="mb-4">
        <Title style={{ paddingLeft: 20, marginBottom: 20 }}>Available Inventory</Title>
        <Col lg="12">
          <Table
          id="inventory-table"
          title="Inventory"
          headers={this.inventoryTableHeaders}
          data={this.state.inventoryTableData}
          colors={["#46c768", "#0da661"]}
          ></Table>
        </Col>
      </Row>
    </Fragment>
  );
}
}
export default withRouter(InventoryPage);
